import {
  max, min, sum, select, scaleBand, scaleLinear
} from 'd3'
import customFormatters from '@/filters/customFormatters'

export default {
  name: 'ExploreWidgetCategoryMultiple',
  mixins: [customFormatters],
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    },
    xKey: {
      type: String,
      default: 'category'
    },
    yKey: {
      type: String,
      default: 'value'
    },
    labels: {
      type: Object,
      default: () => ({
        f: 'Mujeres',
        m: 'Hombres'
      })
    },
    colors: {
      type: Object,
      default: () => ({
        f: 'var(--colorFemale)',
        m: 'var(--colorMale)',
        female: 'var(--colorFemale)',
        male: 'var(--colorMale)'
      })
    },
    minBarHeight: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      width: 0,
      height: 0,
      tooltipData: [],
      tooltipStyles: {
        opacity: 0
      }
    }
  },
  computed: {
    max () {
      return max(this.data, d => sum(d.value, d2 => d2[this.yKey]))
    },
    min () {
      return min(this.data, d => sum(d.value, d2 => d2[this.yKey]))
    },
    xScale () {
      return scaleBand()
        .rangeRound([0, this.width])
        .padding(0.03)
        .domain(this.data.map(d => d[this.xKey]))
    },
    yScale () {
      return scaleLinear()
        .rangeRound([this.height, 0])
        .domain([
          Math.min(this.min, 0),
          this.max
        ])
    }
  },
  mounted () {
    this.width = this.$el.offsetWidth
    this.height = this.$el.offsetHeight
    this.data.forEach(d => {
      let acum = 0
      for (const data of d.value) {
        acum = acum + data[this.yKey]
        data.acum = acum
      }
    })
    this.animate()
    this.setupInteractivity()
  },
  methods: {
    getColor (category) {
      return this.colors[category] || category
    },
    getLabel (category) {
      return this.labels[category] || category
    },
    setupInteractivity () {
      select(this.$el)
        .on('mousemove', () => {
          const ev = window.event
          const bandStep = this.xScale.step()
          const index = Math.floor(ev.layerX / bandStep)
          const category = this.xScale.domain()[index]

          const data = this.data.find(d => d.category === category)
          this.tooltipData = data.value.map(d => ({
            label: `- ${this.getLabel(d[this.xKey])} ${this.getLabel(category)}`,
            value: d[this.yKey],
            color: this.getColor(d[this.xKey])
          })).reverse()

          this.$nextTick(() => {
            const margin = 12
            const x = ev.layerX > (this.width / 2)
              ? (event.layerX - margin - select(this.$el).select('.tooltip').node().offsetWidth)
              : event.layerX + margin

            this.tooltipStyles = {
              opacity: 1,
              transform: `translate(${x}px, ${ev.layerY}px)`
            }
          })
        })
        .on('mouseout', () => {
          this.tooltipStyles = {
            opacity: 0,
            transform: 'none'
          }
        })
    },
    animate () {
      this.$nextTick(() => {
        select(this.$el)
          .selectAll('.bar-group')
          .data(this.data)
          .selectAll('rect')
          .data(d => d.value)
          .transition()
          .duration(500)
          .attr('y', d => this.yScale(d.acum))
          .attr('height', d => this.getBarHeight(d))
      })
    },
    getBarHeight (d) {
      return this.yScale(d.acum - d[this.yKey]) - this.yScale(d.acum)
    }
  }
}
